import React from "react";
import { Button, Tooltip, IconButton } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { useNewsModal } from "../hooks/useNewsModal";

interface ResetNewsButtonProps {
  variant?: "button" | "icon";
  size?: "small" | "medium" | "large";
}

export function ResetNewsButton({
  variant = "icon",
  size = "small",
}: ResetNewsButtonProps) {
  const { resetNewsModal } = useNewsModal();

  const handleReset = () => {
    resetNewsModal();
  };

  if (variant === "button") {
    return (
      <Button
        onClick={handleReset}
        variant="outlined"
        size={size}
        startIcon={<Refresh />}
        sx={{
          borderColor: "#667eea",
          color: "#667eea",
          "&:hover": {
            borderColor: "#5a6fd8",
            backgroundColor: "rgba(102, 126, 234, 0.04)",
          },
        }}
      >
        Ver Novidades
      </Button>
    );
  }

  return (
    <Tooltip title="Ver modal de novidades novamente">
      <IconButton
        onClick={handleReset}
        size={size}
        sx={{
          color: "#667eea",
          "&:hover": {
            backgroundColor: "rgba(102, 126, 234, 0.08)",
          },
        }}
      >
        <Refresh />
      </IconButton>
    </Tooltip>
  );
}
